var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('title')},[_vm._v("Deudas a pagar")]),_c('debts-table',{attrs:{"debts":_vm.debts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }